import { render, staticRenderFns } from "./FTCustomerBizInfo.vue?vue&type=template&id=42d8dde9&"
import script from "./FTCustomerBizInfo.vue?vue&type=script&lang=js&"
export * from "./FTCustomerBizInfo.vue?vue&type=script&lang=js&"
import style0 from "./FTCustomerBizInfo.vue?vue&type=style&index=0&id=42d8dde9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports